/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// Vision UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

// Vision UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

import type { CSSObject } from "@mui/material/styles";

import type { ComponentTheme } from "models/theme.model";

const { grey, info, transparent } = colors;
const { borderRadius } = borders;
const { tabsBoxShadow } = boxShadows;

const tabsTheme: ComponentTheme<"MuiTabs"> = {
  styleOverrides: {
    root: {
      minWidth: "fit-content !important",
      position: "relative",
      background: transparent.main,
      borderRadius: borderRadius.md,
      minHeight: "unset",
      padding: pxToRem(4),
    },

    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 10,
    },

    fixed: {
      overflow: "unset !important",
      // csstype has no `!important` form for this property.
      overflowX: "unset !important" as CSSObject["overflowX"],
    },

    vertical: {
      "& .MuiTabs-indicator": {
        width: "100%",
      },
    },

    indicator: {
      height: "100%",
      borderRadius: borderRadius.lg,
      backgroundColor: info.main,
      transition: "all 500ms ease",
    },
  },
};

export default tabsTheme;
